export const mandatoryCheckboxStyles = (theme) => ({
  documentLink: {
    textDecoration: 'underline',
    cursor: 'pointer',
    marginLeft: 4,
    color: theme.palette.primary.main,
  },
})
